<template>
  <div class="apply_advItem">
    <Header title="发布公告" type="0" route="/adv"></Header>
    <van-form ref="vanForm" validate-first class="mode">
      <van-cell-group>
        <van-field
          v-model="form.content_title.text"
          rows="1"
          autosize
          label="标题"
          input-align="right"
          type="textarea"
          placeholder="请输入"
          @input="val => changeValue(val, 'content_title')"
          required
          :rules="[{ required: true, message: '请输入标题' }]"
        />
        <van-field
          input-align="right"
          v-model="form.contentSort.text"
          label="发布类别"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showPop('发布类别', 'contentSort')"
          required
          :rules="[{ required: true, message: '请选择发布类别' }]"
        />
        <van-field
          input-align="right"
          v-model="form.stratTime.text"
          label="有效开始时间"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showDatePop('有效开始时间', 'stratTime')"
          required
          :rules="[{ required: true, message: '请选择有效开始时间' }]"
        />
        <van-field
          input-align="right"
          v-model="form.endTime.text"
          label="有效结束时间"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showDatePop('有效结束时间', 'endTime')"
          required
          :rules="[{ required: true, message: '请选择有效结束时间' }]"
        />
        <van-field
          type="number"
          input-align="right"
          v-model="form.orders.text"
          label="排序"
          placeholder="请输入"
          @input="val => changeValue(val, 'orders')"
        />
        <van-field
          input-align="right"
          v-model="form.qzid.text"
          label="选择群组"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          :disabled="Boolean(form.roleid.value)"
          @click="showMultPop('选择群组', 'qzid')"
        />
        <van-field
          input-align="right"
          v-model="form.roleid.text"
          label="选择角色"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          :disabled="Boolean(form.qzid.value)"
          @click="showMultPop('选择角色', 'roleid', Boolean(form.qzid.value))"
        />
        <van-field
          input-align="right"
          v-model="form.sfbk.text"
          label="是否必看"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showPop('是否必看', 'sfbk')"
        />
      </van-cell-group>
      <van-cell-group>
        <template>
          <van-field
            class="qz-textarea"
            v-model="form.content1.text"
            rows="6"
            autosize
            label="发布内容"
            type="textarea"
            placeholder="请输入"
            @input="val => changeValue(val, 'content1')"
            required
            :rules="[{ required: true, message: '请输入发布内容' }]"
          />
        </template>
      </van-cell-group>
    </van-form>
    <div class="apply_advItem_button">
      <van-button type="default" @click="cancel">取消</van-button>
      <van-button type="primary" @click="saveData">提交</van-button>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.title"
        show-toolbar
        :columns="valueList.columns"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.field);
          }
        "
      />
    </van-popup>
    <van-popup v-model="showDate" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :title="valueList.title"
        :min-date="minDate"
        @confirm="
          (value, index) => {
            onConfirmDate(value, index, valueList.field);
          }
        "
      />
    </van-popup>
    <van-popup v-model="showMult" class="multPop" round position="bottom">
      <div class="multPop_header">
        <van-checkbox v-model="isAll" @change="toggleAll">
          <template #icon>
            <span class="multPop_header_all">全选</span>
          </template>
        </van-checkbox>
        <h3 class="multPop_header_title">{{ valueList.title }}</h3>
        <van-icon
          class="multPop_header_confirm"
          name="success"
          @click="onConfirmMult"
        />
      </div>
      <van-checkbox-group ref="checkboxGroup" v-model="result">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in valueList.columns"
            clickable
            :key="index"
            :title="item.text"
            @click="toggle(index)"
          >
            <template #right-icon>
              <van-checkbox
                :name="item.value"
                :value="item.text"
                ref="checkboxes"
                checked-color="#7469f8"
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-popup>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      info: {},
      form: {
        // 标题
        content_title: {},
        // 发布类别
        contentSort: {},
        // 开始时间
        stratTime: {},
        // 结束时间
        endTime: {},
        // 排序（数字）
        orders: {},
        // 群组id，多个群组逗号分割（角色和群组只有传一个，并且必须传一个）
        qzid: {},
        // 角色id，多个角色逗号分割（角色和群组只有传一个，并且必须传一个）
        roleid: {},
        // 是否必看（为是时传1）
        sfbk: {},
        // 内容
        content1: {}
      },
      showMult: false,
      result: [],
      isAll: false,
      show: false,
      valueList: {
        title: "",
        field: "",
        columns: []
      },
      columns: {},
      currentDate: new Date(),
      minDate: new Date(1900, 0, 1),
      showDate: false
    };
  },
  created() {
    this.getList();
    Object.keys(this.form).forEach(key => {
      this.form[key] = {
        text: "",
        value: ""
      };
    });
  },
  methods: {
    toggleAll(val) {
      this.$refs.checkboxGroup.toggleAll(val);
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    async getList() {
      const resFblb = await Api.findDictionry({ zzdtype: "ggfblb" });
      if (resFblb.code == 1) {
        this.columns.contentSort = [
          {
            values: resFblb.data.ggfblb.map(item => {
              return {
                text: item.gglbname,
                value: item.gglbid
              };
            })
          }
        ];
      }
      const resQz = await Api.findDictionry({ zzdtype: "roleQz" });
      if (resQz.code == 1) {
        this.columns.qzid = [
          {
            values: resQz.data.roleQz.map(item => {
              return {
                text: item.ggqzname,
                value: item.ggqzid
              };
            })
          }
        ];
      }
      const resRole = await Api.findDictionry({ zzdtype: "role" });
      if (resRole.code == 1) {
        this.columns.roleid = [
          {
            values: resRole.data.role.map(item => {
              return {
                text: item.rolename,
                value: item.roleid
              };
            })
          }
        ];
      }

      this.columns.sfbk = [
        {
          values: [
            {
              text: "否",
              value: "0"
            },
            {
              text: "是",
              value: "1"
            }
          ]
        }
      ];
    },
    changeValue(val, field) {
      this.form[field].value = val;
    },
    cancel() {
      this.$router.back();
    },
    saveData() {
      this.$refs.vanForm.validate().then(
        async () => {
          if (
            Number(this.form.stratTime.value) >= Number(this.form.endTime.value)
          ) {
            this.$toast.fail("有效结束时间要在有效开始时间之后！");
            return;
          }
          if (
            !Boolean(this.form.roleid.value) &&
            !Boolean(this.form.qzid.value)
          ) {
            this.$toast.fail("角色和群组必须选择一个！");
            return;
          }
          let params = {
            content_title: this.form.content_title.value,
            stratTime: this.form.stratTime.value,
            endTime: this.form.endTime.value,
            contentSort: this.form.contentSort.value,
            content1: this.form.content1.value,
            sfbk: this.form.sfbk.value,
            orders: this.form.orders.value,
            roleid: this.form.roleid.value,
            qzid: this.form.qzid.value
          };
          const res = await Api.gglyAdd(params);
          if (res.code == 1) {
            this.$router.replace({
              path: "/adv",
              query: {
                isSuccess: res.code
              }
            });
          }
        },
        () => {}
      );
    },
    // 弹出选择器
    showMultPop(title, field, flag) {
      if (flag) return;
      this.showMult = true;
      this.valueList.title = title;
      this.valueList.field = field;
      this.valueList.columns = this.columns[field][0].values;
    },
    // 选择确认
    onConfirmMult() {
      this.showMult = false;
      let field = this.valueList.field;
      this.form[field].value = this.result.join(",");
      let arr = [];
      this.$refs.checkboxes.forEach(item => {
        if (item.checked) {
          arr.push(item.value);
        }
      });
      this.form[field].text = arr.join(",");
    },
    // 弹出选择器
    showPop(title, field) {
      this.show = true;
      this.valueList.title = title;
      this.valueList.field = field;
      this.valueList.columns = this.columns[field];
    },
    // 选择确认
    onConfirm(value, index, field) {
      this.show = false;
      this.form[field].text = value[0].text;
      this.form[field].value = value[0].value;
      //   this.getList();
    },
    showDatePop(title, field, flag) {
      if (this.form[field].value) {
        let yy = this.form[field].value.substr(0, 4);
        let mm = this.form[field].value.substr(4, 2);
        let dd = this.form[field].value.substr(6, 2);
        let h = this.form[field].value.substr(8, 2);
        let m = this.form[field].value.substr(10, 2);
        this.currentDate = new Date(yy, mm - 1, dd, h, m);
      } else {
        this.currentDate = new Date();
      }

      this.showDate = true;
      this.valueList.title = title;
      this.valueList.field = field;
    },
    onConfirmDate(date, index, field) {
      this.showDate = false;
      let yy = date.getFullYear();
      let mm =
        Number(date.getMonth()) + 1 < 10
          ? "0" + (Number(date.getMonth()) + 1)
          : Number(date.getMonth()) + 1;
      let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let m =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      this.form[field].text =
        yy + "年" + mm + "月" + dd + "日 " + h + ":" + m + ":00";
      this.form[field].value = 
        yy + "-" + mm + "-" + dd + " " + h + ":" + m + ":00";
    }
  }
};
</script>
<style lang="less" scoped>
.apply_advItem {
  height: 100%;
  background-color: #f2f2f4;
  overflow: auto;
  .mode {
    height: calc(~"100% - 78px");
    margin-top: 8px;
    background-color: #f2f2f4;
    overflow: auto;
    /deep/.van-cell-group {
      margin-bottom: 8px;
      .van-cell {
        padding: 14px 15px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        letter-spacing: 0;
        font-weight: 400;
        &::after {
          left: 15px;
          right: 15px;
          border-bottom: 1px solid #e5e5e5;
        }
        .van-field__label {
          width: fit-content;
          span {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 400;
            white-space: nowrap;
          }
        }
        .van-field__error-message {
          text-align: right;
        }
        .van-field__control::placeholder {
          color: #b2b2b2 !important;
        }
        .van-field__right-icon {
          .van-icon {
            color: #b2b2b2;
          }
        }
        .van-field__word-limit {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #b2b2b2;
          letter-spacing: 0.3px;
          font-weight: 400;
        }
        &.qz-textarea {
          flex-direction: column;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          letter-spacing: 0.3px;
          font-weight: 400;
          .van-field__control::placeholder {
            color: #b2b2b2 !important;
          }
        }
      }
    }
  }
  .apply_advItem_button {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 70px;
    background: #ffffff;
    padding: 10px 15px;
    border-top: 1px solid #e5e5e5;
    .van-button {
      height: 100%;
      width: calc(~"50% - 7.5px");
      border: 1px solid #e5e5e5;
      border-radius: 25px !important;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
    }
    .van-button--normal {
      color: #666666;
    }
    .van-button--primary {
      color: #ffffff;
      background-color: #7469f8;
    }
  }
  .multPop {
    .multPop_header {
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e5e5e5;
      padding: 0 16px;
      .multPop_header_all {
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        color: #7469f8;
      }
      .multPop_header_confirm {
        font-size: 25px;
      }
      .multPop_header_title {
        color: #757da3;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
      }
    }
    /deep/.van-checkbox-group {
      height: calc(~"50vh - 55px");
      overflow: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/applyAdvItem.vue